module.exports = __webpack_public_path__ + "static/media/playIcon.2440db7b.svg";